import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
// Fix E (2026-09-04): sale Navigation (era la marca de relleno). Building2 SE QUEDA:
// se sigue usando en el link "Clientes" del nav.
import { LayoutDashboard, Truck, Building2, Users, LogOut, Bell, MessageSquareText, Menu, X, ListOrdered, Layers, KeyRound, Boxes } from "lucide-react";
import { IsotipoLoccitec } from "@/components/marca/LogoLoccitec";
import { useAdminAuth } from "@/lib/adminAuth";
import { ADMIN } from "@/constants/testIds";

export const AdminLayout = () => {
  const { usuario, logout } = useAdminAuth();
  const navigate = useNavigate();
  const [menuAbierto, setMenuAbierto] = useState(false);

  const salir = () => {
    logout();
    navigate("/admin/login");
  };

  const cerrarMenu = () => setMenuAbierto(false);

  const linkClass = ({ isActive }) =>
    `flex items-center gap-2.5 rounded-[var(--tc-radius)] px-3 py-2.5 text-sm font-medium transition-colors ${
      isActive
        ? "bg-[var(--tc-accent)] text-white"
        : "text-[var(--tc-text-secondary)] hover:bg-[var(--tc-accent-soft)] hover:text-[var(--tc-accent)]"
    }`;

  return (
    <div className="flex min-h-screen bg-[var(--tc-surface)]">
      {menuAbierto && (
        <div
          data-testid={ADMIN.sidebarOverlay}
          onClick={cerrarMenu}
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-60 shrink-0 flex-col border-r border-[var(--tc-border)] bg-white transition-transform duration-200 lg:static lg:translate-x-0 ${
          menuAbierto ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between gap-2.5 px-5 py-5">
          <div className="flex items-center gap-2.5">
            {/* Fix E (2026-09-04): la rosa de los vientos del logotipo oficial. */}
            <IsotipoLoccitec className="h-8 w-8 shrink-0" />
            <div className="leading-tight">
              <p className="text-sm font-semibold text-[var(--tc-text)]">Torre de Control</p>
              <p className="text-[10px] font-medium uppercase tracking-wider text-[var(--tc-text-secondary)]">Panel interno</p>
            </div>
          </div>
          <button
            data-testid={ADMIN.sidebarCloseButton}
            onClick={cerrarMenu}
            className="rounded-[var(--tc-radius)] p-1.5 text-[var(--tc-text-secondary)] hover:bg-[var(--tc-surface)] lg:hidden"
          >
            <X size={18} />
          </button>
        </div>

        <nav className="flex flex-1 flex-col gap-1 px-3">
          <NavLink data-testid={ADMIN.sidebarDashboardLink} to="/admin" end onClick={cerrarMenu} className={linkClass}>
            <LayoutDashboard size={17} /> Dashboard
          </NavLink>
          <NavLink data-testid={ADMIN.sidebarUnidadesLink} to="/admin/unidades" onClick={cerrarMenu} className={linkClass}>
            <Truck size={17} /> Unidades
          </NavLink>
          <NavLink data-testid={ADMIN.sidebarEmbarquesLink} to="/admin/embarques" onClick={cerrarMenu} className={linkClass}>
            <Boxes size={17} /> Embarques
          </NavLink>
          <NavLink data-testid={ADMIN.sidebarNotificacionesLink} to="/admin/notificaciones" onClick={cerrarMenu} className={linkClass}>
            <Bell size={17} /> Notificaciones
          </NavLink>
          <NavLink data-testid={ADMIN.sidebarPlantillasLink} to="/admin/plantillas" onClick={cerrarMenu} className={linkClass}>
            <MessageSquareText size={17} /> Plantillas
          </NavLink>
          {usuario?.rol === "admin" && (
            <NavLink data-testid={ADMIN.sidebarEtapasLink} to="/admin/etapas" onClick={cerrarMenu} className={linkClass}>
              <ListOrdered size={17} /> Etapas
            </NavLink>
          )}
          {usuario?.rol === "admin" && (
            <NavLink data-testid={ADMIN.sidebarTiposLink} to="/admin/tipos" onClick={cerrarMenu} className={linkClass}>
              <Layers size={17} /> Tipos de unidad
            </NavLink>
          )}
          {usuario?.rol === "admin" && (
            <NavLink data-testid={ADMIN.sidebarClientesLink} to="/admin/clientes" onClick={cerrarMenu} className={linkClass}>
              <Building2 size={17} /> Clientes
            </NavLink>
          )}
          {usuario?.rol === "admin" && (
            <NavLink data-testid={ADMIN.sidebarUsuariosLink} to="/admin/usuarios" onClick={cerrarMenu} className={linkClass}>
              <Users size={17} /> Usuarios
            </NavLink>
          )}
          <NavLink data-testid={ADMIN.sidebarCuentaLink} to="/admin/cuenta" onClick={cerrarMenu} className={linkClass}>
            <KeyRound size={17} /> Mi cuenta
          </NavLink>
        </nav>

        <div className="border-t border-[var(--tc-border)] p-3">
          <div className="mb-2 px-2">
            <p className="truncate text-sm font-medium text-[var(--tc-text)]">{usuario?.nombre}</p>
            <span
              data-testid={ADMIN.userRoleBadge}
              className="mt-1 inline-block rounded-full bg-[var(--tc-accent-soft)] px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-[var(--tc-accent)]"
            >
              {usuario?.rol}
            </span>
          </div>
          <button
            data-testid={ADMIN.sidebarLogoutButton}
            onClick={salir}
            className="flex w-full items-center gap-2.5 rounded-[var(--tc-radius)] px-3 py-2.5 text-sm font-medium text-[var(--tc-text-secondary)] transition-colors hover:bg-red-50 hover:text-red-600"
          >
            <LogOut size={17} /> Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center gap-3 border-b border-[var(--tc-border)] bg-white px-4 py-3 lg:hidden">
          <button
            data-testid={ADMIN.mobileMenuButton}
            onClick={() => setMenuAbierto(true)}
            className="rounded-[var(--tc-radius)] p-2 text-[var(--tc-text-secondary)] hover:bg-[var(--tc-surface)]"
          >
            <Menu size={20} />
          </button>
          <span className="text-sm font-semibold text-[var(--tc-text)]">Torre de Control</span>
        </header>
        <main className="min-w-0 flex-1 overflow-x-hidden overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
